module.exports = __webpack_public_path__ + "img/5-2.89322c8e.svg";